import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/logo.png";

function TermsAndConditions() {
  return (
    <div className="privacy-page">
      {/* Header */}
      <header className="navbar">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Airlive Logo" />
          </Link>
        </div>
        <nav>
          <Link to="/">Home</Link>
          <Link to="/#about">About</Link>
          <Link to="/#branches">Branches</Link>
          <Link to="/#services">Services</Link>
          <Link to="/#gallery">Gallery</Link>
        </nav>
      </header>

      {/* Terms and Conditions Content */}
      <div className="privacy-content-page">
        <div className="container">
          <button className="close-btn" onClick={() => window.history.back()}>
            ✖
          </button>
          <h1>Terms and Conditions</h1>
          <p><strong>Last Updated: November 26, 2025</strong></p>
          <p>For the purpose of these Terms and Conditions, The term "we", "us", "our" used anywhere on this page shall mean ALIVE HOSPITALITY, whose registered/operational office is 5th, Plot No 5F 31-40, Sarath City Capital Mall, Gachibowli, Miyapur road, Kondapur Hyderabad TELANGANA 500084.</p>
          <p>"you", "your", "user", "visitor" shall mean any natural or legal person who is visiting our website and/or agreed to purchase from us.</p>
          <p>Your use of the website and/or purchase from us are governed by following Terms and Conditions:</p>
          <p>The content of the pages of this website is subject to change without notice.</p>
          <p>Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose.</p>
          <p>You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.</p>
          <p>Your use of any information or materials on our website and/or product pages is entirely at your own risk, for which we shall not be liable.</p>
          <p>It shall be your own responsibility to ensure that any products, services or information available through our website and/or product pages meet your specific requirements.</p>
          <p>Our website contains material which is owned by or licensed to us.</p>
          <p>This material includes, but are not limited to, the design, layout, look, appearance and graphics.</p>
          <p>Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.</p>
          <p>All trademarks reproduced in our website which are not the property of, or licensed to, the operator are acknowledged on the website.</p>
          <p>Unauthorized use of information provided by us shall give rise to a claim for damages and/or be a criminal offense.</p>
          <p>From time to time our website may also include links to other websites.</p>
          <p>These links are provided for your convenience to provide further information.</p>
          <p>You may not create a link to our website from another website or document without ALIVE HOSPITALITY's prior written consent.</p>
          <p>Any dispute arising out of use of our website and/or purchase with us and/or any engagement with us is subject to the laws of India.</p>
          <p>We, shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.</p>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} Alive Hospitality. All Rights Reserved to alive hospitality.</p>
      </footer>
    </div>
  );
}

export default TermsAndConditions;
